import React from 'react';

import CommonImage from '@/components/CommonImage';
function Table() {
	return (
		<div>
			<div className="wraper container-fluid dashboard-container">
				{/* sample-table */}
				<div className="mobile-responsive-table sample-table">
					<div className="single-row">
						<table class="table with-border hover">
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Sample ID*
								</th>
								<td>
									<div className="form-group mb-0">
										<input type="text" placeholder="Sample Id" />
									</div>
								</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Country*</th>
								<td className="type-column">
									<div className="select-component">
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<img src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									QC Approval
								</th>
								<td>
									<div className="form-group mb-0">
										<input type="date" />
									</div>
								</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Sample Type*
								</th>
								<td>bd</td>
							</tr>

							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Brand/Factory
								</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Color</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Size</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Sample Location*
								</th>
								<td>
									<div className="select-component">
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<img src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Location Updated by
								</th>
								<td>bd</td>
							</tr>

							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Remarks</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Sample Status
								</th>
								<td>
									<div className="select-component">
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<img src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01"></th>
								<td>
									<div className="option">
										<div className="dropdown">
											<button
												aria-expanded="false"
												className="btn btn-default dropdown-toggle"
												data-toggle="dropdown"
												id="menu1"
												type="button"
											>
												<CommonImage src="/icons/more_icon.svg" alt="more_icon" />
											</button>
											<ul
												aria-labelledby="menu1"
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												x-placement="bottom-end"
											>
												<li className="px-4 pb-3 pt-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
														role="menuitem"
														tabIndex={-1}
													>
														Edit
													</a>
												</li>
												<li className="px-4 pb-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href
														role="menuitem"
														tabIndex={-1}
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</td>
							</tr>
						</table>
					</div>
				</div>

				{/* material-table */}
				<div className="mobile-responsive-table material-table">
					<div className="single-row">
						<p class="semibold-12 gray_dark_02 mt-3 mb-2">Trims</p>
						<table class="table with-border hover">
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Image</th>
								<td>
									<CommonImage src="/images/t-shirt-orange.png" class="cell-img pr-2" />
								</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Placement</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Reference</th>
								<td class="placement-column">
									<span className="regular-14 gray_dark_01">
										<p className="text-underline cursor-pointer">F23-A2762</p>
										<p className="mt-1">Lorem</p>
										<p>lorem</p>
									</span>
									<p class="regular-12 gray_dark_01 text-underline mt-12 cursor-pointer">
										Roadmap
									</p>
								</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Material details
								</th>
								<td>
									<p className="regular-12 gray_dark_03">Knit (Jersey)</p>
									<p className="regular-14 gray_dark_01 mb-2">Heavy Jersey</p>
									<p className="regular-14 gray_dark_01 text-nowrap">100 % Cotton</p>
									<p className="regular-14 gray_dark_01 mt-2">240 GSM</p>
								</td>
							</tr>

							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Color</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Shrinkage & GSM
								</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Nitex inventory book Qty
								</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Sample consumption
								</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Location Updated by
								</th>
								<td>bd</td>
							</tr>

							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Supplier</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">
									Sample Status
								</th>
								<td>bd</td>
							</tr>
							<tr>
								<th className="align-middle regular-14 weight-500 gray_dark_01">Remarks</th>
								<td></td>
							</tr>
						</table>
					</div>
				</div>
				<div className="container-fluid p-5">
					<table className="table">
						<thead>
							<tr>
								<th>Checkbox</th>
								<th>Text</th>
								<th>Double line text</th>
								<th>Image</th>
								<th>4 Image</th>
								<th>3 Image</th>
								<th>Checkbox, Avatar &amp; Text</th>
								<th>Status</th>
								<th>Status</th>
								<th>Logo</th>
								<th>Edit Cell</th>
								<th className="text-right">Action/More</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												id="person1"
												name="Company"
												type="checkbox"
												defaultValue={113}
											/>
											<label htmlFor="person1" />
										</div>
									</div>
								</td>
								<td>Text Cell</td>
								<td>
									<span>
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<img alt="" className="cell-img pr-2" src=" /images/tshirt.jpg" />
									<span className="d-inline-block align-middle">
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<div className="four-collection">
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
									</div>
								</td>
								<td>
									<div className="three-collection">
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<div className="two">
											<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
											<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										</div>
									</div>
								</td>
								<td>
									<div className="custom-chekbox d-inline-block align-middle">
										<div className="form-group m-0">
											<input
												id="person2"
												name="Company"
												type="checkbox"
												defaultValue={113}
											/>
											<label htmlFor="person2" />
										</div>
									</div>
									<div className="add-buyer d-inline-block align-middle">
										<div className="added-members px-2">
											<img
												alt=""
												data-original-title="Sadat"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
											<img
												alt=""
												data-original-title="Mamun"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
											<img
												alt=""
												data-original-title="Mamun"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
										</div>
									</div>
									<span className="d-inline-block align-middle">
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<div className="task-status purple">
										<span className="status-btn">Status</span>
									</div>
								</td>
								<td>
									<div className="task-status green">
										<span className="status-btn">
											Status
											<svg
												fill="none"
												height={18}
												viewBox="0 0 18 18"
												width={18}
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
													stroke="#00C334"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M12.7245 6.29999L7.69488 11.3295L5.3999 9.0345"
													stroke="#00C334"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
											</svg>
										</span>
										<span className="time-count">+2d</span>
									</div>
								</td>
								<td>
									<img alt="" src=" /images/brand-logo.png" />
								</td>
								<td>
									<input type="text" defaultValue="Edit Cell" />
								</td>
								<td className="text-right">
									<div className="option">
										<div className="dropdown">
											<button
												aria-expanded="false"
												className="btn btn-default dropdown-toggle"
												data-toggle="dropdown"
												id="menu1"
												type="button"
											>
												<svg
													fill="none"
													height={24}
													viewBox="0 0 24 24"
													width={24}
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
														fill="#6A7181"
													/>
												</svg>
											</button>
											<ul
												aria-labelledby="menu1"
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												x-placement="bottom-end"
											>
												<li className="px-4 pb-3 pt-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
														role="menuitem"
														tabIndex={-1}
													>
														Edit
													</a>
												</li>
												<li className="px-4 pb-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href
														role="menuitem"
														tabIndex={-1}
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<td>
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												id="person1"
												name="Company"
												type="checkbox"
												defaultValue={113}
											/>
											<label htmlFor="person1" />
										</div>
									</div>
								</td>
								<td>Text Cell</td>
								<td>
									<span>
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<img alt="" className="cell-img pr-2" src=" /images/tshirt.jpg" />
									<span className="d-inline-block align-middle">
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<div className="four-collection">
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
									</div>
								</td>
								<td>
									<div className="three-collection">
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<div className="two">
											<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
											<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										</div>
									</div>
								</td>
								<td>
									<div className="custom-chekbox d-inline-block align-middle">
										<div className="form-group m-0">
											<input
												id="person2"
												name="Company"
												type="checkbox"
												defaultValue={113}
											/>
											<label htmlFor="person2" />
										</div>
									</div>
									<div className="add-buyer d-inline-block align-middle">
										<div className="added-members px-2">
											<img
												alt=""
												data-original-title="Sadat"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
											<img
												alt=""
												data-original-title="Mamun"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
											<img
												alt=""
												data-original-title="Mamun"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
										</div>
									</div>
									<span className="d-inline-block align-middle">
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<div className="task-status purple">
										<span className="status-btn">Status</span>
									</div>
								</td>
								<td>
									<div className="task-status green">
										<span className="status-btn">
											Status
											<svg
												fill="none"
												height={18}
												viewBox="0 0 18 18"
												width={18}
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
													stroke="#00C334"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M12.7245 6.29999L7.69488 11.3295L5.3999 9.0345"
													stroke="#00C334"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
											</svg>
										</span>
										<span className="time-count">+2d</span>
									</div>
								</td>
								<td>
									<img alt="" src=" /images/brand-logo.png" />
								</td>
								<td>
									<input type="text" defaultValue="Edit Cell" />
								</td>
								<td className="text-right">
									<div className="option">
										<div className="dropdown">
											<button
												aria-expanded="false"
												className="btn btn-default dropdown-toggle"
												data-toggle="dropdown"
												id="menu1"
												type="button"
											>
												<svg
													fill="none"
													height={24}
													viewBox="0 0 24 24"
													width={24}
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
														fill="#6A7181"
													/>
												</svg>
											</button>
											<ul
												aria-labelledby="menu1"
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												x-placement="bottom-end"
											>
												<li className="px-4 pb-3 pt-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
														role="menuitem"
														tabIndex={-1}
													>
														Edit
													</a>
												</li>
												<li className="px-4 pb-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href
														role="menuitem"
														tabIndex={-1}
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<td>
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												id="person1"
												name="Company"
												type="checkbox"
												defaultValue={113}
											/>
											<label htmlFor="person1" />
										</div>
									</div>
								</td>
								<td>Text Cell</td>
								<td>
									<span>
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<img alt="" className="cell-img pr-2" src=" /images/tshirt.jpg" />
									<span className="d-inline-block align-middle">
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<div className="four-collection">
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
									</div>
								</td>
								<td>
									<div className="three-collection">
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<div className="two">
											<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
											<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										</div>
									</div>
								</td>
								<td>
									<div className="custom-chekbox d-inline-block align-middle">
										<div className="form-group m-0">
											<input
												id="person2"
												name="Company"
												type="checkbox"
												defaultValue={113}
											/>
											<label htmlFor="person2" />
										</div>
									</div>
									<div className="add-buyer d-inline-block align-middle">
										<div className="added-members px-2">
											<img
												alt=""
												data-original-title="Sadat"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
											<img
												alt=""
												data-original-title="Mamun"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
											<img
												alt=""
												data-original-title="Mamun"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
										</div>
									</div>
									<span className="d-inline-block align-middle">
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<div className="task-status purple">
										<span className="status-btn">Status</span>
									</div>
								</td>
								<td>
									<div className="task-status green">
										<span className="status-btn">
											Status
											<svg
												fill="none"
												height={18}
												viewBox="0 0 18 18"
												width={18}
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
													stroke="#00C334"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M12.7245 6.29999L7.69488 11.3295L5.3999 9.0345"
													stroke="#00C334"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
											</svg>
										</span>
										<span className="time-count">+2d</span>
									</div>
								</td>
								<td>
									<img alt="" src=" /images/brand-logo.png" />
								</td>
								<td>
									<input type="text" defaultValue="Edit Cell" />
								</td>
								<td className="text-right">
									<div className="option">
										<div className="dropdown">
											<button
												aria-expanded="false"
												className="btn btn-default dropdown-toggle"
												data-toggle="dropdown"
												id="menu1"
												type="button"
											>
												<svg
													fill="none"
													height={24}
													viewBox="0 0 24 24"
													width={24}
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
														fill="#6A7181"
													/>
												</svg>
											</button>
											<ul
												aria-labelledby="menu1"
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												x-placement="bottom-end"
											>
												<li className="px-4 pb-3 pt-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
														role="menuitem"
														tabIndex={-1}
													>
														Edit
													</a>
												</li>
												<li className="px-4 pb-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href
														role="menuitem"
														tabIndex={-1}
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</td>
							</tr>
							<tr>
								<td>
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												id="person1"
												name="Company"
												type="checkbox"
												defaultValue={113}
											/>
											<label htmlFor="person1" />
										</div>
									</div>
								</td>
								<td>Text Cell</td>
								<td>
									<span>
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<img alt="" className="cell-img pr-2" src=" /images/tshirt.jpg" />
									<span className="d-inline-block align-middle">
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<div className="four-collection">
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
									</div>
								</td>
								<td>
									<div className="four-collection">
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
										<img alt="" className="cell-img" src=" /images/tshirt.jpg" />
									</div>
								</td>
								<td>
									<div className="custom-chekbox d-inline-block align-middle">
										<div className="form-group m-0">
											<input
												id="person2"
												name="Company"
												type="checkbox"
												defaultValue={113}
											/>
											<label htmlFor="person2" />
										</div>
									</div>
									<div className="add-buyer d-inline-block align-middle">
										<div className="added-members px-2">
											<img
												alt=""
												data-original-title="Sadat"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
											<img
												alt=""
												data-original-title="Mamun"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
											<img
												alt=""
												data-original-title="Mamun"
												data-placement="top"
												data-toggle="tooltip"
												src=" /images/alave.png"
												title
											/>
										</div>
									</div>
									<span className="d-inline-block align-middle">
										Text Cell <br />
										<span className="subtext">Text Cell</span>
									</span>
								</td>
								<td>
									<div className="task-status purple">
										<span className="status-btn">Status</span>
									</div>
								</td>
								<td>
									<div className="task-status green">
										<span className="status-btn">
											Status
											<svg
												fill="none"
												height={18}
												viewBox="0 0 18 18"
												width={18}
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
													stroke="#00C334"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M12.7245 6.29999L7.69488 11.3295L5.3999 9.0345"
													stroke="#00C334"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
											</svg>
										</span>
										<span className="time-count">+2d</span>
									</div>
								</td>
								<td>
									<img alt="" src=" /images/brand-logo.png" />
								</td>
								<td>
									<input type="text" defaultValue="Edit Cell" />
								</td>
								<td className="text-right">
									<div className="option">
										<div className="dropdown">
											<button
												aria-expanded="false"
												className="btn btn-default dropdown-toggle"
												data-toggle="dropdown"
												id="menu1"
												type="button"
											>
												<svg
													fill="none"
													height={24}
													viewBox="0 0 24 24"
													width={24}
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
														fill="#6A7181"
													/>
												</svg>
											</button>
											<ul
												aria-labelledby="menu1"
												className="dropdown-menu dropdown-menu-right shadow-lg"
												role="menu"
												x-placement="bottom-end"
											>
												<li className="px-4 pb-3 pt-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href="/invoices/edit/10052"
														role="menuitem"
														tabIndex={-1}
													>
														Edit
													</a>
												</li>
												<li className="px-4 pb-3" role="presentation">
													<a
														className="font-weight-normal  text-black"
														href
														role="menuitem"
														tabIndex={-1}
													>
														Delete
													</a>
												</li>
											</ul>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className="project-planning-table mt-3">
					<h1 className="semibold-14 px-3">Project Planning table</h1>
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-12">
								<section className="task-table-design project-planning-table d-flex ">
									<div className="task-left-section">
										<div className="fixed-tasks text-center style-base-list">
											<div className="one-box heading-box first-heading right-border">
												<p>Style</p>
											</div>
											<div className="one-box right-border">
												<img alt="" src=" /images/index3.png" />
												<p>
													<a href="#">Style 1 Name</a>
												</p>
											</div>
											<div className="one-box right-border">
												<img alt="" src=" /images/index2.png" />
												<p>
													<a href="#">Style 2 Name</a>
												</p>
											</div>
											<div className="one-box right-border">
												<img alt="" src=" /images/index1.png" />
												<p>
													<a href="#">Style 3 Name</a>
												</p>
											</div>
											<div className="one-box right-border">
												<img alt="" src=" /images/index3.png" />
												<p>
													<a href="#">Style 4 Name</a>
												</p>
											</div>
											<div className="one-box right-border">
												<img alt="" src=" /images/index2.png" />
												<p>
													<a href="#">Style 5 Name</a>
												</p>
											</div>
											<div className="one-box right-border">
												<img alt="" src=" /images/index1.png" />
												<p>
													<a href="#">Style 6 Name</a>
												</p>
											</div>
											<div className="one-box bottom-border right-border">
												<img alt="" src=" /images/index3.png" />
												<p>
													<a href="#">Style 7 Name</a>
												</p>
											</div>
										</div>
									</div>
									<div className="task-right-section clearfix">
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Fabric quality submission</p>
											</div>
											<div className="one-box left-no-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column text-center">
											<div className="one-box heading-box ">
												<p>Fabric quality approval</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column text-center">
											<div className="one-box heading-box ">
												<p>Lab dips submission</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														{' '}
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column text-center">
											<div className="one-box heading-box ">
												<p>Lab dips submission</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column text-center">
											<div className="one-box heading-box ">
												<p>Strike off submision</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column text-center">
											<div className="one-box heading-box">
												<p>Trims card approval</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column text-center">
											<div className="one-box heading-box">
												<p>Fit sample submission</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column text-center">
											<div className="one-box heading-box">
												<p>Strike off submision</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column text-center">
											<div className="one-box heading-box">
												<p>Strike off submision</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column text-center">
											<div className="one-box heading-box">
												<p>Strike off submision</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
										<div className="task-full-column last-task-full-column text-center">
											<div className="one-box heading-box">
												<p>Strike off submision</p>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
											<div className="one-box bottom-border">
												<p>4</p>
												<input type="text" defaultValue={4} />
												<div className="edit-buttons">
													<a href="#">
														<img alt="" src=" /icons/toggle-right.svg" />
													</a>
													<a href="#">
														<img alt="" src=" /icons/edit.svg" />
													</a>
												</div>
											</div>
										</div>
									</div>
								</section>
							</div>
						</div>
					</div>
				</div>
				<div className="order-profile-table mt-3">
					<h1 className="semibold-14 px-3">Order profile table</h1>
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-12">
								<section className="task-table-design order-table-view style-wise-task-view d-flex ">
									<div className="task-left-section">
										<div className="fixed-tasks text-center style-base-list">
											<div className="one-box heading-box first-heading right-border">
												<p>Style</p>
											</div>
											<div className="one-box right-border">
												<img alt="" src=" /images/index3.png" />
												<p>
													<a href="#">Style 1 Name</a>
												</p>
											</div>
											<div className="one-box right-border">
												<img alt="" src=" /images/index2.png" />
												<p>
													<a href="#">Style 2 Name</a>
												</p>
											</div>
											<div className="one-box right-border">
												<img alt="" src=" /images/index1.png" />
												<p>
													<a href="#">Style 3 Name</a>
												</p>
											</div>
											<div className="one-box bottom-border right-border">
												<img alt="" src=" /images/index3.png" />
												<p>
													<a href="#">Style 7 Name</a>
												</p>
											</div>
										</div>
									</div>
									<div className="task-right-section clearfix">
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Design sketch approval</p>
											</div>
											<div className="one-box left-no-border pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
											<div className="one-box approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />{' '}
													<span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box bottom-border approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
										</div>
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Technical specifications</p>
											</div>
											<div className="one-box left-no-border pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box expired">
												<p>
													Apr-26 <span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />{' '}
													<span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box bottom-border approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
										</div>
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Complete measurement grading</p>
											</div>
											<div className="one-box approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />{' '}
													<span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box expired">
												<p>
													Apr-26 <span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box bottom-border approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
										</div>
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Measurement chart approval</p>
											</div>
											<div className="one-box left-no-border pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box not-applicable">
												<p>N/A</p>
											</div>
											<div className="one-box expired">
												<p>
													Apr-26 <span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box bottom-border approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
										</div>
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Main label placement and size</p>
											</div>
											<div className="one-box left-no-border pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box not-applicable">
												<p>N/A</p>
											</div>
											<div className="one-box expired">
												<p>
													Apr-26 <span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box bottom-border approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
										</div>
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Main label content finalization</p>
											</div>
											<div className="one-box left-no-border pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
											<div className="one-box approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />{' '}
													<span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box bottom-border approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
										</div>
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Wash label content finalization</p>
											</div>
											<div className="one-box left-no-border pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box not-applicable">
												<p>N/A</p>
											</div>
											<div className="one-box expired">
												<p>
													Apr-26 <span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box bottom-border approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
										</div>
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Techpack ready to share</p>
											</div>
											<div className="one-box left-no-border pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box expired">
												<p>
													Apr-26 <span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />{' '}
													<span className="due-count">+2d</span>
												</p>
											</div>
											<div className="one-box bottom-border approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
										</div>
										<div className="task-full-column first-task-full-column text-center">
											<div className="one-box heading-box left-no-border">
												<p>Fabric quality submission</p>
											</div>
											<div className="one-box left-no-border pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box not-applicable">
												<p>N/A</p>
											</div>
											<div className="one-box pending">
												<p>Apr-26</p>
											</div>
											<div className="one-box bottom-border approved">
												<p>
													Apr-26 <img alt="" src=" /icons/approve-icon.svg" />
												</p>
											</div>
										</div>
									</div>
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
export default Table;
